import React from 'react';

import {InventoryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import PrintLabelButton from 'label-printing/PrintLabelButton';
import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';
import {MultiSelectionBox, Table} from 'notebook/tables/TableConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import {StructuredTableColumn} from '../StructuredTableConstants';
import getBarcodePrintableIdsInSelection from './getBarcodePrintableIdsInSelection';

export interface PrintBarcodesButtonProps {
  table: Table;
  multiSelectionBox: MultiSelectionBox | null;
  columns: Array<StructuredTableColumn>;
  computedTable: Array<Array<EvaluatedCell>> | null;
}

/**
 * Reusable component for extracting printable plate/container IDs from a table and presenting them
 * for printing
 */
export default function PrintBarcodesButton({
  table,
  multiSelectionBox,
  columns,
  computedTable,
}: PrintBarcodesButtonProps): JSX.Element | null {
  if (!isFeatureEnabled({feature: InventoryFeature.INVENTORY_EXPORT})) {
    return null;
  }

  let printableIds: Array<string> = [];
  let tooltip: string | null = null;

  if (computedTable != null) {
    const printableIdsResult = getBarcodePrintableIdsInSelection(
      multiSelectionBox,
      columns,
      computedTable,
      table.rowData || []
    );
    printableIds = printableIdsResult.printableIds;
    tooltip = printableIdsResult.tooltip;
  }

  return (
    <Tooltip title={tooltip} disabled={printableIds.length > 0}>
      <span>
        <PrintLabelButton
          buttonSize={ButtonSize.MINI}
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          className="u-mini-spacing-left"
          disabled={printableIds.length === 0}
          itemIds={printableIds}
        />
      </span>
    </Tooltip>
  );
}
